function WorkflowStepper({ isVerified, isSent, onVerify, onOpenEnvoi, modalId }) {
  return (
    <div className="workflow-stepper">
      <div className="workflow-step ws-done">
        <div className="ws-circle"><i className="bi bi-check-lg"></i></div>
        <div className="ws-label">Brouillon</div>
        <div className="ws-sublabel">Créé</div>
        <div className="ws-action"></div>
      </div>

      <div className={`workflow-step ${isVerified ? 'ws-done-vert' : 'ws-active-vert'}`}>
        <div className="ws-circle">{isVerified ? <i className="bi bi-check-lg"></i> : '2'}</div>
        <div className="ws-label">Vérification</div>
        <div className="ws-sublabel">{isVerified ? 'Validé' : 'En attente'}</div>
        <div className="ws-action">
          {!isVerified && (
            <button type="button" className="btn-axian-vert ws-btn" onClick={onVerify}>Vérifier</button>
          )}
        </div>
      </div>

      <div className={`workflow-step ${isSent ? 'ws-done-cramoisie' : (isVerified ? 'ws-active-cramoisie' : '')}`}>
        <div className="ws-circle">{isSent ? <i className="bi bi-check-lg"></i> : '3'}</div>
        <div className="ws-label">Envoi</div>
        <div className="ws-sublabel">{isSent ? 'Envoyé' : (isVerified ? 'Prêt à envoyer' : '')}</div>
        <div className="ws-action">
          {isVerified && !isSent && (
            <button type="button" className="btn-axian-cramoisie ws-btn"
              data-bs-toggle="modal" data-bs-target={'#' + modalId} onClick={onOpenEnvoi}>
              Notifier
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default WorkflowStepper;
